'use strict';

var _ = require('lodash');
var StrategyGroupDirective = function StrategyGroupDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'StrategyGroupController',
    template: require('../templates/strategy-group.html'),
    scope: {
      strategyGroup: '=',
      levelOptions: '=',
      onSelectStrategyGroup: '&',
      onSelectStrategyCondition: '&',
      level: '=',
      activeEntityType: '=',
      flowType: '=',
      defaultCollection: '@',
      isStatementEmpty: '=',
      statementBoxToggle: '=',
      groupIndex: '=',
      strategy: '='
    },
    link: function link($scope) {
      $scope.selectedLevel = {
        value: $scope.level
      };
      $scope.$watch('selectedLevel.value', $scope.selectedLevelChanged);
      $scope.$watch('level', function (level) {
        if (level) {
          $scope.selectedLevel.value = level;
        }
      });
      if (_.isUndefined($scope.selectedLevel.value)) {
        $scope.selectedLevel.value = _.find($scope.levelOptions, {
          'domain': $scope.strategyGroup.level
        });
        if ($scope.selectedLevel.value === undefined) {
          $scope.selectedLevel.value = _.head($scope.levelOptions);
        }
      }
    }
  };
};
StrategyGroupDirective.$inject = [];
module.exports = StrategyGroupDirective;